export const defaultDonationsObj = {
  'id': -1001,
  'temp_id': 1002,
  'name': '',
  'description': '',
  'goal': 0, // Donation Goal
  'prefilled_amount': 200, // Default donation amount
  'is_active': true,
  'placement_index': 1
};
